import type { FunctionalComponent as FC } from 'preact';
import { useCallback } from 'preact/compat';

import { Icon28Favorite } from '@vkontakte/icons';
import { Headline } from '@vkontakte/vkui';
import { clsx } from 'clsx';
import { Rating } from 'react-simple-star-rating';

import { useWidget } from '../../context/WidgetContext';

import styles from './styles.module.css';

interface Props {
  className?: string;
  rating?: number;
  onChangeRating?: (rate: number) => void;
  readonly?: boolean;
}

export const RateAnswer: FC<Props> = ({ className, rating, onChangeRating, readonly }) => {
  const { localeMessages } = useWidget();
  const handleRating = useCallback(
    (rate: number) => {
      onChangeRating?.(rate);
    },
    [onChangeRating]
  );

  return (
    <div className={clsx(styles.rateAnswer, className)}>
      <Headline level="1">{localeMessages.chat.rateAnswerTitle}</Headline>
      <Rating
        emptyClassName={styles.emptyIcons}
        fillClassName={styles.filledIcons}
        emptyIcon={<Icon28Favorite width={28} height={28} fill="#B8C1CC" />}
        fillIcon={<Icon28Favorite width={28} height={28} fill="#F9B54F" />}
        titleSeparator={localeMessages.chat.rateAnswerOf}
        initialValue={rating}
        onClick={handleRating}
        readonly={readonly}
      />
    </div>
  );
};
